import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getIssuesComponent, getErrorIssues, getWarningIssues } from '../../../../../../../utils/validationSummary';
import { ASTRO_DIM } from '../../../../../../../utils/constantFeatures';
import { InputTime } from './InputTime';

class PropertyTableTimePicker extends React.Component {

    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    isOn(property) {
        return property.value !== undefined
            && property.value !== null
            && property.value !== ''
            && property.value.toUpperCase() !== 'OFF'
            && property.value !== property.valueMeta.off;
    }

    handleChange(e) {
        e.preventDefault();
        const value = e.target.value;
        const name = e.target.name;
        if (value === null || value === '') {

            return;
        }

        this.props.handleChange(name, value);
    }

    renderFirstRow(type) {
        // Output

        const columns = [];

        if(this.props.displayColors){
            columns.push(
                <Col style={{ padding: '0' }} key={`${type}0`}>
                    <input
                        id={`${type}0`}
                        disabled
                        className={'input-property-picker'}
                        name={`${type}0`}
                        type="number"
                        min={0}
                        max={0}
                        value={0} />
                </Col>
            );
        }

        Object.keys(this.props.properties).sort().forEach((key) => {

            if (this.props.properties[key].info.name.includes(type)) {
                if(this.props.properties[key].value === 'Off'){
                    this.props.properties[key].value = 0
                }
                const errors = getErrorIssues(this.props.issues, this.props.properties[key]);
                const warnings = getWarningIssues(this.props.issues, this.props.properties[key]);

                const className = `input-property-picker ${errors.length > 0 ? 'danger' : warnings.length > 0 ? 'warning' : ''}`;

                columns.push(
                    <Col style={{ padding: '0' }} key={this.props.properties[key].id}>
                        <input
                            id={key}
                            disabled={this.props.disabled}
                            className={className}
                            name={this.props.properties[key].info.name}
                            type="number"
                            min={this.props.properties[key].valueMeta.min}
                            max={this.props.properties[key].valueMeta.max}
                            value={this.props.properties[key].value}
                            onChange={this.handleChange} />
                        {getIssuesComponent(errors, warnings)}
                    </Col>
                );
            }

        });

        columns.push(
            <Col style={{ padding: '0' }} key={`${type}6`}>
                <input
                    id={`${type}6`}
                    disabled
                    className={'input-property-picker'}
                    name={`${type}6`}
                    type="number"
                    min={0}
                    max={0}
                    value={0} />
            </Col>
        );

        return columns;
    }

    renderSecondRow(type) {
        // Time

        const columns = [];

        if(this.props.displayColors){
            columns.push(
                <Col style={{ padding: '0' }} key={`${type}0`}>
                    <input
                        id={`${type}0`}
                        disabled
                        className={'input-property-picker'}
                        name={`${type}0`}
                        type="text"
                        min={0}
                        max={0}
                        value={'OFF'} />
                </Col>
            );
        }

        columns.push(
            <Col style={{ padding: '0' }} key={`${type}1`}>
                <input
                    id={`${type}1`}
                    disabled
                    className={'input-property-picker'}
                    name={`${type}1`}
                    // type="time"
                    type="text"
                    value={this.props.properties[ASTRO_DIM.submode].value === "0" ? 'ON' : '00:00'} />
            </Col>
        );

        Object.keys(this.props.properties).sort().forEach((key) => {

            if (this.props.properties[key].info.name.includes(type)) {

                const errors = getErrorIssues(this.props.issues, this.props.properties[key]);
                const warnings = getWarningIssues(this.props.issues, this.props.properties[key]);

                const className = `input-property-picker ${errors.length > 0 ? 'danger' : warnings.length > 0 ? 'warning' : ''}`;

                if (this.props.properties[key].info.name === ASTRO_DIM.time2 && (this.props.properties[ASTRO_DIM.submode].value === "2")) {
                    columns.push(
                        <Col style={{ padding: '0' }} key={this.props.properties[key].id}>
                            <input
                                id={key}
                                disabled={true}
                                className={className}
                                name={this.props.properties[key].info.name}
                                type="text"
                                min={this.props.properties[key].valueMeta.min}
                                max={this.props.properties[key].valueMeta.max}
                                value={"SD"}
                                onChange={this.handleChange} />
                            {getIssuesComponent(errors, warnings)}
                        </Col>
                    );
                }
                else if ( this.props.properties[ASTRO_DIM.submode].value === "0" ) {
                    columns.push(
                        <Col style={{ padding: '0' }} key={this.props.properties[key].id}>
                            <input
                                id={key}
                                disabled={this.props.disabled}
                                className={className}
                                name={this.props.properties[key].info.name}
                                type="time"
                                min={this.props.properties[key].valueMeta.min}
                                max={this.props.properties[key].valueMeta.max}
                                value={this.props.properties[key].value}
                                onChange={this.handleChange} />
                            {getIssuesComponent(errors, warnings)}
                        </Col>
                    );
                } else {
                    columns.push(
                        <Col style={{ padding: '0' }} key={this.props.properties[key].id}>
                            <InputTime
                                id={key}
                                disabled={this.props.disabled}
                                className={className}
                                name={this.props.properties[key].info.name}
                                value={this.props.properties[key].value}
                                onChange={(value) => value && this.props.handleChange(this.props.properties[key].info.name, value)} />
                            {getIssuesComponent(errors, warnings)}
                        </Col>
                    );
                }
            }
        });

        columns.push(
            <Col style={{ padding: '0' }} key={`${type}6`}>
                <input
                    id={`${type}6`}
                    disabled
                    className={'input-property-picker'}
                    name={`${type}6`}
                    type="text"
                    value={'OFF'} />
            </Col>
        );

        return columns;
    }

    renderThirdRow(type) {
        // Color
        const columns = [];

        columns.push(
            <Col style={{ padding: '0' }} key={`${this.props.extraProperties['ast8.ci'].id}-0`}>
                <input
                    id={`${this.props.extraProperties['ast8.ci'].id}-1`}
                    disabled={this.props.disabled}
                    className={'input-property-picker'}
                    name={this.props.extraProperties['ast8.ci'].info.name}
                    type="number"
                    min={this.props.extraProperties['ast8.ci'].valueMeta.min}
                    max={this.props.extraProperties['ast8.ci'].valueMeta.max}
                    value={this.props.extraProperties['ast8.ci'].value}
                    onChange={this.handleChange} />
            </Col>
        );

        Object.keys(this.props.extraProperties).sort().forEach((key) => {
            if (this.props.extraProperties[key].info.name.includes(type)) {
                if(this.props.extraProperties[key].value === 'Off'){
                    this.props.extraProperties[key].value = 0
                }
                const errors = getErrorIssues(this.props.issues, this.props.extraProperties[key]);
                const warnings = getWarningIssues(this.props.issues, this.props.extraProperties[key]);

                const className = `input-property-picker ${errors.length > 0 ? 'danger' : warnings.length > 0 ? 'warning' : ''}`;

                columns.push(
                    <Col style={{ padding: '0' }} key={this.props.extraProperties[key].id}>
                        <input
                            id={key}
                            disabled={this.props.disabled}
                            className={className}
                            name={this.props.extraProperties[key].info.name}
                            type="number"
                            min={this.props.extraProperties[key].valueMeta.min}
                            max={this.props.extraProperties[key].valueMeta.max}
                            value={this.props.extraProperties[key].value}
                            onChange={this.handleChange} />
                        {getIssuesComponent(errors, warnings)}
                    </Col>
                );
            }

        });

        columns.push(
            <Col style={{ padding: '0' }} key={`${this.props.extraProperties['ast8.ci'].id}-1`}>
                <input
                    id={`${this.props.extraProperties['ast8.ci'].id}-1`}
                    disabled
                    className={'input-property-picker'}
                    name={this.props.extraProperties['ast8.ci'].info.name}
                    type="number"
                    min={this.props.extraProperties['ast8.ci'].valueMeta.min}
                    max={this.props.extraProperties['ast8.ci'].valueMeta.max}
                    value={this.props.extraProperties['ast8.ci'].value}
                    onChange={this.handleChange} />
            </Col>
        );

        return columns;
    }

    render() {

        return (
            <div>
                <Row style={{ margin: '0', paddingTop: '0.5rem' }}>
                    <Col sm={this.props.sizeTitle} style={{ paddingRight: '0.5rem' }}>
                        {this.props.firstRow.title}
                    </Col>

                    {this.renderFirstRow(this.props.firstRow.property)}

                    <Col sm={this.props.sizeMeasureUnit} style={{ paddingLeft: '0.5rem' }}>
                        {this.props.firstRow.measureUnit}
                    </Col>
                </Row>

                {this.props.displayColors
                    ?
                    <Row style={{ margin: '0', paddingTop: '1rem' }}>
                        <Col sm={this.props.sizeTitle} style={{ paddingRight: '0.5rem' }}>
                            {this.props.thirdRow.title}
                        </Col>

                        {this.renderThirdRow(this.props.thirdRow.property)}

                        <Col sm={this.props.sizeMeasureUnit} style={{ paddingLeft: '0.5rem' }}>
                            {this.props.thirdRow.measureUnit}
                        </Col>
                    </Row>
                    :
                    null
                }

                <Row style={{ margin: '0', paddingTop: '1rem' }}>
                    <Col sm={this.props.sizeTitle} style={{ paddingRight: '0.5rem' }}>
                        {this.props.secondRow.title}
                    </Col>

                    {this.renderSecondRow(this.props.secondRow.property)}

                    <Col sm={this.props.sizeMeasureUnit} style={{ paddingLeft: '0.5rem' }}>
                        {this.props.secondRow.measureUnit}
                    </Col>
                </Row>

            </div>
        );
    };
}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
        issues: state.project.issueByProperty,
    };
};

const mapDispatchToProps = {
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PropertyTableTimePicker);
